﻿import React, { useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import { useMutation } from '@tanstack/react-query';
import { GetDocumentContent, UpdateRequest } from '../../../../api/sfd';
import DownloadIcon from '@mui/icons-material/Download';
import {
  base64ToBlob,
  blobToDownloadableUrl,
  downloadFileNoExtension,
  getFileExtension,
} from '../../../../components/Utilities/HelperMethods';

export default function AgentRequestDownloadWidget({ docID, reqID, isExpired }) {
  const [isDownloading, setIsDownloading] = useState(false);

  const getDocumentContent = useMutation({
    mutationFn: (data) => GetDocumentContent(data)(),
  });

  const updateRequest = useMutation({
    mutationFn: (data) => UpdateRequest(data)(),
  });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
    >
      {isDownloading ? (
        <Box sx={{ paddingLeft: '12px' }}>
          <CircularProgress size="24px" />
        </Box>
      ) : (
        <Tooltip title="Download">
          <span>
            <IconButton
              disabled={isExpired === 'Expired'}
              color="primary"
              onClick={() => {
                setIsDownloading(true);
                getDocumentContent.mutate([{ queryParam: 'documentID', queryVal: docID }], {
                  onSuccess: (data) => {
                    base64ToBlob(data.content, {
                      type: `application/${getFileExtension(data.docName)}`,
                    }).then((result) => {
                      const url = blobToDownloadableUrl(result);
                      downloadFileNoExtension(url, data.docName);

                      updateRequest.mutate(
                        { requestID: reqID, status: 3, iPAddress: '' },
                        {
                          onSuccess: () => {
                            setIsDownloading(false);
                          },
                        }
                      );
                    });
                  },
                });
              }}
            >
              <DownloadIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
}
